import { motion } from "framer-motion";

import { Navbar } from "@/components/Navbar";

import { StepFiles, StepIndicator, StepPersonal, StepSelectPro, StepSubjective } from "./wizard/Steps";
import { StepPayment } from "./wizard/StepPayment";
import { useWizard } from "./wizard/useWizard";

const STEP_ANIM = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.25 },
};

function StepContent({ w }) {
  switch (w.step) {
    case 1:
      return <StepSelectPro pros={w.pros} selectedPro={w.selectedPro} onSelect={w.setSelectedPro} onNext={() => w.setStep(2)} />;
    case 2:
      return <StepPersonal personal={w.personal} setPersonal={w.setPersonal} whatsapp={w.whatsapp} setWhatsapp={w.setWhatsapp} edad={w.edad} onBack={() => w.setStep(1)} onNext={() => w.setStep(3)} />;
    case 3:
      return (
        <StepSubjective
          subj={w.subj}
          setSubj={w.setSubj}
          budget={w.budget}
          setBudget={w.setBudget}
          busy={w.busy}
          onBack={() => w.setStep(2)}
          onNext={w.saveAndContinue}
        />
      );
    case 4:
      if (!w.requestId) return null;
      return <StepFiles requestId={w.requestId} files={w.files} setFiles={w.setFiles} onBack={() => w.setStep(3)} onNext={() => w.setStep(5)} />;
    case 5:
      return (
        <StepPayment
          selectedPro={w.selectedPro}
          personal={w.personal}
          edad={w.edad}
          files={w.files}
          setFiles={w.setFiles}
          requestId={w.requestId}
          busy={w.busy}
          onBack={() => w.setStep(4)}
          onSubmit={w.submit}
        />
      );
    default:
      return null;
  }
}

export default function NewRequest() {
  const w = useWizard();
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-2xl mx-auto px-4 sm:px-6 py-10" data-testid="new-request-wizard">
        <h1 className="text-2xl sm:text-3xl font-bold mb-8">Nueva solicitud de receta</h1>
        <StepIndicator step={w.step} onStepClick={w.setStep} />
        <motion.div key={w.step} {...STEP_ANIM}>
          <StepContent w={w} />
        </motion.div>
      </main>
    </div>
  );
}
